import {Fragment, PureComponent} from 'react'
import {connect} from 'react-redux'
import {CardText} from 'reactstrap'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import {Link} from 'react-router-dom'

import FreelanceExamples from '../../../components/FreelanceExamples/FreelanceExamples.jsx'
import GetMissions from '../../../components/GetMissions/GetMissions.jsx'
import HowToGetMissions from '../../../components/HowToGetMissions/HowToGetMissions.jsx'
import Header from '../../../components/Header/Header.jsx'
// import JoinCommunity from '../../../components/JoinCommunity/JoinCommunity.jsx';
import LandingUniverse from '../LandingUniverse.jsx'
import LinkAs from '../../../components/LinkAs/LinkAs.jsx'
import OfferExampleCard from '../../../components/OfferExample/Card/OfferExampleCard.jsx'
import Partnerships from '../../../components/Partnerships/Partnerships.jsx'

import {generate} from '../../../routes.js'
import {isUserFreelance} from '../../../../shared/services/userService.js'

import offersExamples from '../../OffersExamples/offers-examples.json'

import './LandingFreelanceUniverse.scss'

class LandingFreelanceUniverse extends PureComponent {
  static propTypes = {
    headerImg: PropTypes.string.isRequired,
    headerImgAlt: PropTypes.string.isRequired,
    headerBrief: PropTypes.string.isRequired,
    metaDescription: PropTypes.string.isRequired,
    metaOgDescription: PropTypes.string.isRequired,
    metaTitle: PropTypes.string.isRequired,
    metaOgTitle: PropTypes.string.isRequired,
    sectorText: PropTypes.string,
    title: PropTypes.string.isRequired,
    universeCode: PropTypes.string.isRequired
  }

  static defaultProps = {
    sectorText: 'qui vous correspond',
  }

  renderOfferCards = () => {
    const offers = offersExamples?.[this.props.universeCode]?.length ? offersExamples[this.props.universeCode] : []

    return offers.filter(offer => offer.highlightPosition)
      .sort((first, second) => first.highlightPosition - second.highlightPosition)
      .map((offer, index) => (
        <OfferExampleCard key={index} footer={offer.localization} tag="li" title={offer.title}>
          <CardText><span className="title">Secteur : </span>{offer.area}</CardText>
          <CardText><span className="title">Séniorité : </span>{offer.experience}</CardText>
          <CardText><span className="title">Dates : </span>{offer.dates}</CardText>
          <CardText><span className="title">Mission : </span>{offer.mission}</CardText>
          <ul className="keywords d-flex flex-wrap justify-content-center pl-0">
            {offer.keywords.map((keyword, index) => <li className="py-1 px-2" key={index}>{keyword}</li>)}
          </ul>
        </OfferExampleCard>
      ))
  }

  render() {
    const {currentUniverse, headerImg, headerImgAlt, headerBrief, title, sectorText, ...props} = this.props

    const headerCtas = <Fragment>
      <LinkAs
        className="btn btn-primary"
        notConnected={generate({name: 'register-freelance'})}
        freelance={generate({name: 'offers'})}
      >
        {isUserFreelance ? 'Consulter les missions' : 'Nous rencontrer'}
      </LinkAs>
    </Fragment>

    return <LandingUniverse {...props} className="landing-freelance-universe">
      <Helmet>
        <title>{props.metaTitle}</title>
        <meta name="description" content={props.metaDescription}/>
        <meta property="og:title" content={props.metaOgTitle}/>
        <meta property="og:description" content={props.metaOgDescription}/>
        <meta property="twitter:title" content={props.metaOgTitle}/>
        <meta property="twitter:description" content={props.metaOgDescription}/>
      </Helmet>

      <Header
        brief={headerBrief}
        ctas={headerCtas}
        imageAlt={headerImgAlt}
        imageSrc={headerImg}
        title={title}
      />

      <div className="bg-light">
        <section className="container text-center py-5">
          <h2 className="mb-4">Exemples de missions réalisées</h2>
          <ul id="offers" className="card-deck flex-wrap flex-md-nowrap justify-content-center mb-4">
            {this.renderOfferCards()}
          </ul>
          {currentUniverse !== null ?
            <Link className="btn btn-primary" to={generate({
              name: currentUniverse.code === 'engineering'
                ? 'register-freelance'
                : `offers-examples-${currentUniverse.code}`
            })}>
              Voir des exemples de mission
            </Link>
            : ''
          }
        </section>
      </div>

      <HowToGetMissions/>
      <div className="bg-light">
        <FreelanceExamples universeCode={props.universeCode}/>
      </div>
      {/*<div className="bg-light">*/}
      {/*  <JoinCommunity/>*/}
      {/*</div>*/}
      <GetMissions/>
      <Partnerships/>
    </LandingUniverse>
  }
}

export default connect(
  state => ({
    currentUniverse: state.universe.currentUniverse,
    isUserFreelance: isUserFreelance(state.currentUser.user),
  })
)(LandingFreelanceUniverse)
